import { PixType } from './type'
import Visual from './Visual'

const Pix = ({ paymentMethod }: PixType) => {
  return <Visual paymentMethod={paymentMethod} />
}

export default Pix
